import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaInstagram,
  FaHeart,
  FaShoppingCart,
  FaArrowRight,
  FaClock,
  FaUtensils,
  FaCircle,
} from "react-icons/fa";
import { AiFillGithub } from "react-icons/ai";
import { useSelector } from "react-redux";
import { MdDeliveryDining, MdSecurity, MdSupportAgent } from "react-icons/md";

const Footer = () => {
const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const goLogin = () => {
    setMenuOpen(false);
    navigate("/login");
  };

  const goRegister = () => {
    setMenuOpen(false);
    navigate("/register");
  };

  const goHome = () => {
    setMenuOpen(false);
    navigate("/");
  };

  const scrollToSection = (id) => {
    setMenuOpen(false);

    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
    <footer className="bg-neutral-950 px-4 py-12 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
            {/* Brand */}
            <div className="lg:col-span-2">
              <button
                type="button"
                onClick={goHome}
                className="flex cursor-pointer items-center gap-3 text-left"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-red-500 text-white">
                  <MdDeliveryDining className="text-2xl" />
                </div>

                <div>
                  <div className="text-lg font-black text-white">
                    Foodbite<span className="text-red-500">24</span>
                  </div>

                  <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-neutral-500">
                    Rider Partner
                  </div>
                </div>
              </button>

              <p className="mt-5 max-w-md text-sm leading-7 text-neutral-500">
                Join Foodbite24 as a delivery partner and create flexible
                earning opportunities around your own schedule.
              </p>

              <div className="mt-6 flex items-center gap-2 text-xs font-bold text-neutral-500">
                <FaCircle className="text-[7px] text-green-500" />
                Rider support available
              </div>
            </div>

            {/* Rider */}
            <div>
              <h3 className="text-sm font-black text-white">Rider</h3>

              <div className="mt-5 grid gap-3">
                <button
                  type="button"
                  onClick={goLogin}
                  className="text-left text-sm font-semibold text-neutral-500 transition hover:text-red-400"
                >
                  Rider Login
                </button>

                <button
                  type="button"
                  onClick={goRegister}
                  className="text-left text-sm font-semibold text-neutral-500 transition hover:text-red-400"
                >
                  Join as Rider
                </button>

                <button
                  type="button"
                  onClick={() => scrollToSection("how-it-works")}
                  className="text-left text-sm font-semibold text-neutral-500 transition hover:text-red-400"
                >
                  How It Works
                </button>
              </div>
            </div>

            {/* Support */}
            <div>
              <h3 className="text-sm font-black text-white">Support</h3>

              <div className="mt-5 grid gap-4">
                <a
                  href="tel:+8801336116868"
                  className="flex items-center gap-3 text-sm font-semibold text-neutral-500 transition hover:text-red-400"
                >
                  <FaPhoneAlt className="text-red-500" />
                  +880 1336-116868
                </a>

                <div className="flex items-center gap-3 text-sm font-semibold text-neutral-500">
                  <MdSecurity className="text-lg text-red-500" />
                  Secure Rider Experience
                </div>

                <div className="flex items-center gap-3 text-sm font-semibold text-neutral-500">
                  <MdSupportAgent className="text-lg text-red-500" />
                  Dedicated Support
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 border-t border-white/10 pt-6">
            <div className="flex flex-col gap-3 text-xs font-semibold text-neutral-600 sm:flex-row sm:items-center sm:justify-between">
              <p>
                © {new Date().getFullYear()} Foodbite24. All rights reserved.
              </p>

              <p>Built for Foodbite24 Riders</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;